export const userBrowser = () => {
    console.log(navigator.userAgent);
    return navigator.userAgent;
}